export const FP_WATERMARK_URL = 'https://go2.futuresplatform.com/sites/default/files/watermark-fp.png'

export const INITIALS_COLOR_BY_ALIAS = {
  rising: '#A1E5CD',
  summary: '#A1E5CD',
  cooling: '#9BCFFB',
  wildcard: '#EBB6B4',
  weaksignal: '#D8D8D8',
  established: '#97BACF',
  undefined: '#8FDFC2',
}

export function getTypeBubbleSize(typeAlias) {
  return String(typeAlias) === 'summary' ? 21 : 16
}

export function getInitialsFontScale(typeAlias) {
  return String(typeAlias) === 'undefined' ? 0.7 : 1
}

export function getGroupInitials(group, publicPhenomenaGroups) {
  const thirdPartyGroup = (Number(group) !== 0 && publicPhenomenaGroups && publicPhenomenaGroups.length)
    ? publicPhenomenaGroups.find((pg) => Number(pg.id) === Number(group) || Number(pg.value) === Number(group))
    : null
  const name = thirdPartyGroup?.name || thirdPartyGroup?.label
  return name
    ?.split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .filter(Boolean)
    .join('') || ''
}
